import api from "./index";
import axios, { AxiosResponse, CancelTokenSource } from "axios";
import { VoucherSubmitType } from "../types";

export const getVouchers = async ({
  organizationId,
  queryString,
  count,
}: {
  organizationId: number[] | undefined;
  queryString?: string;
  count?: number;
}) => {
  if (!organizationId) return;

  const { data }: AxiosResponse = await api.get(
    `/v1/user/vouchers?${
      organizationId?.length
        ? `&organization_ids=${organizationId.join(",")}`
        : ""
    }&count=${
      count || 10
    }&skip_line_fields=true&showValidatedByUser=true&${queryString}`
  );
  return data;
};

export const getVoucherById = async (id: number | string) => {
  if (!id) return;
  const {
    data: { data },
  }: AxiosResponse = await api.get(`/v1/vouchers/${id}?showboxes=true`);
  return data;
};

export const getVoucherHistory = async (id: number) => {
  if (!id) return;
  const {
    data: { data },
  }: AxiosResponse = await api.get(`/v1/vouchers/${id}/history`);
  return data;
};

export const deleteVoucherById = async (id: number | number[]) => {
  let requests: Promise<any>[] = [];

  if (!Array.isArray(id)) {
    requests.push(api.delete(`/v1/vouchers/${id}`));
  } else {
    requests = id.map((voucherId: string | number) =>
      api.delete(`/v1/vouchers/${voucherId}`)
    );
  }

  return await Promise.allSettled(requests);
};

export const downloadVoucherById = async (IDs: number[]) => {
  let requests: Promise<any>[] = IDs.map((voucherId: number) =>
    api.get(`/v1/vouchers/${voucherId}/pdf`, { responseType: "blob" })
  );
  return await Promise.allSettled(requests);
};

export const uploadVouchers = async (
  organizationID: number | undefined,
  files: File[]
) => {
  const requests = [];

  for (let i = 0; i < files.length; i++) {
    if (files && files[i]) {
      const formData = new FormData();
      formData.append("image", files[i]);
      requests.push(
        api.post(`/v1/organizations/${organizationID}/vouchers`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      );
    }
  }
  return await Promise.allSettled(requests);
};

export const submitVoucher = async (
  voucherID: number,
  data: VoucherSubmitType
) => {
  return await api.patch(`/v1/vouchers/${voucherID}/validate`, data);
};

let cancelToken: CancelTokenSource;
export const formatFields = async (data: {
  headerField: string;
  ocrText: string[];
}) => {
  if (typeof cancelToken != typeof undefined) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return await api.post("/v1/voucher/formatboxselection", data, {
    cancelToken: cancelToken.token,
  });
};
